<template>
  <div class="row">
    <w-input class="col-12 form-group" :model="schema.attachmentName" />

    <w-datepicker class="col-6 form-group" :model="schema.date" />

    <w-select v-if="schema.type" class="col-12 form-group" :model="schema.type" :values="types" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz rozdzielnika
export default {
  components,
  props: {
    // schema rozdzielnika
    schema: { type: Object, required: true }
  },
  data() {
    return {
      types: [
        { text: 'Konkursy artystyczne', value: 1 },
        { text: 'Konkursy wiedzowe - szkoły podstawowe', value: 2 },
        { text: 'Konkursy wiedzowe - szkoły ponadpodstawowe', value: 3 }
      ]
    };
  }
};
</script>
